var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.onBookClassic)?_c('PromoBookClassic',{on:{"goBackToGame":function($event){_vm.onBookClassic = false}}}):_c('Game',{on:{"goToBookClassic":function($event){_vm.onBookClassic = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }